module.exports = __webpack_public_path__ + "static/img/ddcj02.8d99258.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/ddcj02.jpg
// module id = 1431
// module chunks = 0